import React, { useState, useEffect } from 'react';
import DataTable from '../Common/DataTable';
import { api } from '../../services/api';
import { SENT_MESSAGES_DEFAULT_COLUMNS } from './messageConstants';
import './Messages.css';

export default function SentMessagesReport({ user, selectedContractId, search, tableActionsRef }) {
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!selectedContractId || !user) return;

    setColumns([]);
    setData([]);

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await api.getSentMessagesReport(
          user.userCode,
          user.type,
          selectedContractId
        );

        setColumns(response.columns?.length ? response.columns : SENT_MESSAGES_DEFAULT_COLUMNS);
        setData(response.data || []);
      } catch (err) {
        console.error('Error fetching sent messages:', err);
        setError(err.message);
        setColumns(SENT_MESSAGES_DEFAULT_COLUMNS);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedContractId, user]);

  if (loading && columns.length === 0) {
    return (
      <div className="report-panel report-panel--state">
        <div className="report-state-message">טוען...</div>
      </div>
    );
  }

  if (error && data.length === 0) {
    return (
      <div className="report-panel report-panel--state">
        <div className="report-state-message report-state-message--error">
          שגיאה בטעינת הדוח: {error}
        </div>
      </div>
    );
  }

  if (!columns || columns.length === 0) {
    return (
      <div className="report-panel report-panel--state">
        <div className="report-state-message">אין עמודות להצגה</div>
      </div>
    );
  }

  return (
    <div className="report-panel">
      <DataTable
        ref={tableActionsRef}
        columns={columns}
        data={data}
        search={search}
      />
    </div>
  );
}
